import Axios from "../../services/axios-service";

const getCountriesList = async () => {
  return await Axios.get("/api/GetCountryList", undefined, undefined);
};
const getCountriesListByRegion = async () => {
  return await Axios.get(
    "/api/RiskLineRegionWiseCountryList",
    undefined,
    undefined
  );
};
const getAllCovidData = async () => {
    console.log(await Axios.get("api/risklineAlert/covid/", undefined, undefined));
    return await Axios.get(
        "api/risklineAlert/covid/",
        undefined,
        undefined
    );
};
const getMyAccount = async () => {
  return await Axios.get("/api/Users/Profile", undefined, undefined);
};
const updateMyAccount = async data => {
  return await Axios.put("/api/Users/Profile", data, undefined);
};
const getTotalSales = args => {
  return Axios.post("/api/DashBoard/TotalSale", args, undefined);
};
const getTotalIncome = args => {
  return Axios.post("/api/DashBoard/TotalIncome", args, undefined);
};
const getTotalProfit = args => {
  return Axios.post("/api/DashBoard/TotalProfit", args, undefined);
};
const getTotalSaleByProduct = args => {
  return Axios.post("/api/DashBoard/TotalSaleProductWise", args, undefined);
};
const checkInEventlog = args => {
  return Axios.post("/api/CheckInEventlog", args, undefined);
};

const getValidCountriesList = async () => {
  return await Axios.get("/api/GetValidCountryList ", undefined, undefined);
};
const getDashboardNotificationsData = args => {
  return Axios.post("/api/DashBoard/TotalEventSummary", args, undefined);
};
const getItinerariesOverview = args => {
  return Axios.get(
    "/api/iternary/fetchitinerariesOverview?orgId=" +
      args.orgId +
      "&startDate=" +
      args.startDate +
      "&endDate=" +
      args.endDate,
    undefined
  );
};

const loadEmergencyContacts = () => {
  return Axios.get("/api/CountryReport/EmergencyNum/", undefined, undefined);
};

const getResellerTotalOrders = args => {
  return Axios.post("/api/DashBoard/TotalResellerOrders", args, undefined);
};
const getResellerTotalProfit = args => {
  return Axios.post("/api/DashBoard/TotalResellerProfit", args, undefined);
};
const getResellerTotalSale = args => {
  return Axios.post("/api/DashBoard/ResellerTotalSaleProductWise", args, undefined);
};

const hasB2B2CEmergencyContact = (userId) => {
  return Axios.get("/api/B2B2CEmergencyContactExists/"+userId, undefined, undefined);
};

const updateB2B2CEmergencyContact = (userId, data) => {
  return Axios.put("/api/UpdateB2B2CEmergencyContact/"+userId, data, undefined);
};

const createCountryState = (args) => {
  return Axios.post("/api/CreateCountryState", args, undefined);
};

const updateCountryState = (id, args) => {
  return Axios.put("/api/UpdateCountryState/"+id, args, undefined);
};

const getCountryStateList = data => {
  return Axios.get("/api/GetCountryStatesList?search=" + encodeURIComponent(JSON.stringify(data)), undefined, undefined);
};

const getCountryStateById = (id) => {
  return Axios.get("/api/GetCountryStateInfo/"+id, undefined, undefined);
};

const getStateRiskZones = () => {
  return Axios.get("/api/GetStatesRiskZones", undefined, undefined);
};

const deleteState = id => {
  return Axios.delete("/api/DeleteCountryState/"+id, undefined, undefined);
};

const getGendersList = () => {
  return Axios.get("/api/GetGendersList", undefined, undefined);
};

const createuserrequest = data => {
  return Axios.post("/api/createuserrequest", data, undefined);
};

export default {
  getCountriesList,
  getCountriesListByRegion,
  getAllCovidData,
  getMyAccount,
  updateMyAccount,
  getTotalSales,
  getTotalIncome,
  getTotalProfit,
  getTotalSaleByProduct,
  checkInEventlog,
  getValidCountriesList,
  getDashboardNotificationsData,
  getItinerariesOverview,
  loadEmergencyContacts,
  getResellerTotalOrders,
  getResellerTotalProfit,
  getResellerTotalSale,
  hasB2B2CEmergencyContact,
  updateB2B2CEmergencyContact,
  createCountryState,
  updateCountryState,
  getCountryStateList,
  getCountryStateById,
  getStateRiskZones,
  deleteState,
  getGendersList,
  createuserrequest
};
